import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretRightDouble20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconCaretRightDouble20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.53 3.47a.75.75 0 1 0-1.06 1.06L14.94 10l-5.47 5.47a.75.75 0 0 0 1.06 1.06l6-6 .53-.53-.53-.53zm-6 0a.75.75 0 0 0-1.06 1.06L8.94 10l-5.47 5.47a.75.75 0 0 0 1.06 1.06l6-6 .53-.53-.53-.53z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretRightDouble20);
